/**
 * Default: Modules > Clinic Management > Map
 *
 * @copyright 2025 i-fabrik GmbH
 * @author Tobias Garz
 */

import SelectorEngine from '../../../../shared/dom/selector-engine';
import EventHandler from '../../../../shared/dom/event-handler';
import Manipulator from '../../../../shared/dom/manipulator';
import Data from '../../../../shared/dom/data';

// -------
// Private
// -------

const NAME = 'clinic-management';

const initMapToggles = () => {
	const COLLECTION = SelectorEngine.find(`.${NAME}-filter .button[data-target]`);

	if(!COLLECTION.length) {
		return;
	}

	for(const ELEMENT of COLLECTION) {
		EventHandler.on(ELEMENT, 'click', (event) => {
			let target = Manipulator.getDataAttribute(ELEMENT, 'target');
			let map    = SelectorEngine.findOne(`${target}`);

			if(!map) {
				return;
			}

			if(Data.get(map, 'visible')) {
				Data.set(map, 'visible', false);

				Manipulator.removeClass(map, '-active');
				Manipulator.removeClass(ELEMENT, '-active');
			} else {
				Data.set(map, 'visible', true);

				Manipulator.addClass(map, '-active');
				Manipulator.addClass(ELEMENT, '-active');
			}
		});
	}
};

// -------
// Public
// -------

// -------
// Execute
// -------

window.addEventListener("load", () => {
	initMapToggles();
});